module.exports = __webpack_public_path__ + "static/img/bg-ar.a6fc1672.png";